import { BaseModel } from '../../base.model';

export class EquipmentTypeToCompanyDto extends BaseModel {
  public CompanyID: string;
  public VPCompanyID: number;
  public CompanyName: string;
  public bActive: boolean;

  constructor(o: any = null) {
    super(o);
  }
}
